var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "example-wrap" },
    [
      _c("json-viewer", {
        attrs: {
          value: _vm.optionsShow,
          "expand-depth": 5,
          copyable: "",
          boxed: "",
          sort: "",
          theme: "json-theme"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c(
            "div",
            { staticClass: "top-setting" },
            [
              _c("p", [
                _vm._v(
                  "\n                如果选父节点子节点不联动（selectChildren：false），且只输出子节点（onlyOutPutLeafNode：true），选父节点没有任何效果等同于changeOnSelect为false\n            "
                )
              ]),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: {
                  label: "selectChildren--是否父子联动(仅多选有效, 默认false)"
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.selectChildren,
                  callback: function($$v) {
                    _vm.selectChildren = $$v
                  },
                  expression: "selectChildren"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: {
                  label:
                    "onlyOutPutLeafNode--只输出叶子节点(仅多选有效, 默认false)"
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.onlyOutPutLeafNode,
                  callback: function($$v) {
                    _vm.onlyOutPutLeafNode = $$v
                  },
                  expression: "onlyOutPutLeafNode"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: {
                  label: "collapseTags--是否折叠label(仅多选有效, 默认false)"
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.collapseTags,
                  callback: function($$v) {
                    _vm.collapseTags = $$v
                  },
                  expression: "collapseTags"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: { label: "filterable--是否可搜索" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.filterable,
                  callback: function($$v) {
                    _vm.filterable = $$v
                  },
                  expression: "filterable"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: { label: "showAllLevels--是否展示全部label" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.showAllLevels,
                  callback: function($$v) {
                    _vm.showAllLevels = $$v
                  },
                  expression: "showAllLevels"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: { label: "disabled--是否禁用" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.disabled,
                  callback: function($$v) {
                    _vm.disabled = $$v
                  },
                  expression: "disabled"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: { label: "changeOnSelect--是否可以选任意一级" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.changeOnSelect,
                  callback: function($$v) {
                    _vm.changeOnSelect = $$v
                  },
                  expression: "changeOnSelect"
                }
              }),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: {
                  label:
                    "appendToBody--是否挂载到body上，选否需用parent-el属性提供挂载元素选择器"
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.appendToBody,
                  callback: function($$v) {
                    _vm.appendToBody = $$v
                  },
                  expression: "appendToBody"
                }
              }),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.expandTrigger,
                    callback: function($$v) {
                      _vm.expandTrigger = $$v
                    },
                    expression: "expandTrigger"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "click" } }, [
                    _vm._v("click触发菜单")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "hover" } }, [
                    _vm._v("hover触发菜单")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("el-checkbox", {
                attrs: {
                  label:
                    "currentActiveValue--多选模式是否以指定路径打开菜单，demo设置为[1, 11, 51]"
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.currentActiveValue,
                  callback: function($$v) {
                    _vm.currentActiveValue = $$v
                  },
                  expression: "currentActiveValue"
                }
              }),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  attrs: { placeholder: "分隔符", label: "分隔符" },
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.separator,
                    callback: function($$v) {
                      _vm.separator = $$v
                    },
                    expression: "separator"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("分隔符")])],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.shouldReset
            ? _c("el-multi-cascader", {
                staticClass: "multi-cascader",
                attrs: {
                  options: _vm.options,
                  multiple: "",
                  currentActiveValue: _vm.currentActiveValue ? [1, 11, 51] : [],
                  "select-children": _vm.selectChildren,
                  "only-out-put-leaf-node": _vm.onlyOutPutLeafNode,
                  "collapse-tags": _vm.collapseTags,
                  filterable: _vm.filterable,
                  "show-all-levels": _vm.showAllLevels,
                  "expand-trigger": _vm.expandTrigger,
                  separator: _vm.separator,
                  disabled: _vm.disabled,
                  clearable: _vm.clearable,
                  "change-on-select": _vm.changeOnSelect,
                  "append-to-body": _vm.appendToBody,
                  size: "medium",
                  "parent-el": ".multi-cascader"
                },
                on: {
                  change: _vm.valueChange,
                  "active-item-change": _vm.handleItemChange
                },
                model: {
                  value: _vm.selectedOptions,
                  callback: function($$v) {
                    _vm.selectedOptions = $$v
                  },
                  expression: "selectedOptions"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-value" },
            _vm._l(_vm.selectedOptions, function(item) {
              return _c(
                "span",
                { key: Array.isArray(item) ? item.join(",") : item },
                [_vm._v(_vm._s(item))]
              )
            })
          ),
          _vm._v(" "),
          _vm.shouldReset
            ? _c("el-multi-cascader", {
                staticClass: "multi-cascader",
                attrs: {
                  options: _vm.options2,
                  filterable: _vm.filterable,
                  "show-all-levels": _vm.showAllLevels,
                  "expand-trigger": _vm.expandTrigger,
                  separator: _vm.separator,
                  disabled: _vm.disabled,
                  clearable: _vm.clearable,
                  "change-on-select": _vm.changeOnSelect
                },
                model: {
                  value: _vm.selectedOptions2,
                  callback: function($$v) {
                    _vm.selectedOptions2 = $$v
                  },
                  expression: "selectedOptions2"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-value" },
            _vm._l(_vm.selectedOptions2, function(item) {
              return _c(
                "span",
                { key: Array.isArray(item) ? item.join(",") : item },
                [_vm._v(_vm._s(item))]
              )
            })
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9794c84", { render: render, staticRenderFns: staticRenderFns })
  }
}